/* Keep list contents inside their own cells, including legacy fixed-width columns. */
.cms-data-table {
  table-layout: auto !important;
}

.cms-cell-value {
  display: contents;
}

.cms-data-table :is(th, td) {
  overflow-wrap: anywhere;
}

.cms-data-table td > :not([role='tooltip']),
.cms-data-table td :is(.flex, .inline-flex, .grid):not([role='tooltip']) {
  max-width: 100%;
}

.cms-data-table td :is(.flex, .inline-flex, .grid) > :is(span, div, a, p) {
  min-width: 0;
}

.cms-data-table td :is(span, p, a, strong, small):not(.truncate) {
  min-width: 0;
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
}

@media (max-width: 639px) {
  .cms-data-table {
    display: block;
    width: 100% !important;
    min-width: 0 !important;
  }

  .cms-data-table colgroup {
    display: none;
  }

  .cms-data-table thead {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
  }

  .cms-data-table :is(tbody, tfoot) {
    display: grid;
    gap: 12px;
    padding: 12px;
  }

  .cms-data-table tbody:empty {
    min-height: 96px;
  }

  .cms-data-table :is(tbody, tfoot) > tr {
    display: flex;
    flex-direction: column;
    min-width: 0;
    padding: 4px 14px;
    border: 1px solid #e3e9ed;
    border-radius: 12px;
    background: white;
  }

  .cms-data-table :is(tbody, tfoot) > tr > :is(td, th) {
    display: grid;
    grid-template-columns: minmax(72px, 30%) minmax(0, 1fr);
    align-items: start;
    gap: 12px;
    width: auto !important;
    min-width: 0 !important;
    max-width: 100%;
    padding: 10px 0 !important;
    border: 0 !important;
    border-bottom: 1px solid #edf1f3 !important;
    text-align: left !important;
    white-space: normal !important;
  }

  .cms-data-table :is(tbody, tfoot) > tr > :last-child {
    border-bottom: 0 !important;
  }

  .cms-data-table .cms-cell-value {
    display: block;
    min-width: 0;
    grid-column: 2;
    font-size: 12px;
    line-height: 1.5;
  }

  .cms-data-table .cms-cell-value .truncate {
    overflow: visible;
    white-space: normal;
    overflow-wrap: anywhere;
    text-overflow: clip;
  }

  .cms-data-table :is(td, th)[data-mobile-stack='true'] {
    display: block;
  }

  .cms-data-table :is(td, th)[data-label]:not([data-label=''])::before {
    display: block;
    margin-bottom: 0;
    color: #778596;
    font-size: 11px;
    font-weight: 500;
    font-family: var(--font-sans);
    content: attr(data-label);
  }

  .cms-data-table :is(td, th)[data-mobile-stack='true']::before {
    margin-bottom: 8px;
  }

  .cms-data-table td[data-label='#'] {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #778596;
  }

  .cms-data-table td[data-label='#']::before {
    margin-bottom: 0;
  }

  .cms-data-table td[data-label='#'] .cms-cell-value {
    color: #778596;
    font-size: 11px;
  }

  .cms-data-table td [class*='min-w-'] {
    min-width: 0 !important;
  }

  .cms-data-table .cms-cell-value > .flex {
    align-items: flex-start;
  }

  .cms-data-table .cms-cell-value > .inline-flex {
    flex-wrap: wrap;
  }
}
